import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { accountInitialize } from "store/accountActions";

import { staticData } from "managers/staticDataManager";

const { default: Dropdown } = require("react-multilevel-dropdown")

const LaguageBar = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { languages } = useSelector(state => state.staticData);
  const account = useSelector(state => state.account);

  const changeLanguageHandler = (e) => {
    let code = e.target.getAttribute("data-key");
    let language = languages.find(lang => lang.code === code);

    // console.log("account?.language?.code, language?.code: ", account?.language?.code, language?.code);
    if(account?.language?.code !== language?.code) {
      dispatch(accountInitialize({ language })); 
      history.push(`/`);
    }
  }

  return(

    <Dropdown key="dropdown-language" title={staticData.loadTerms(useSelector, `VW_COMMON_LANGUAGE`)} wrapperClassName="ml-auto">
      {languages.filter(l => l.isUsedFromPublishingDocuments).map(lang => (
        <Dropdown.Item key={`dropdown-item-${lang.code}`} data-key={lang.code} onClick={(e) => changeLanguageHandler(e)}>
          {lang.description}
        </Dropdown.Item>)
      )}
    </Dropdown>

  )
}

export default LaguageBar;